import { GasStationModel } from "./GasStationModel";
import { PriceCorrectionModel } from "./PriceCorrectionModel";
import { GasStationCorrectionModel } from "./GasStationCorrectionModel";
import { AppUtils } from '../../../../../shared/utils/index';

export enum FeedbackType {
	PRICE, GASSTATION
}

export class FeedbackFormModel {
	// flow conrol only
	public Modifed: boolean;

	private entdecktAm = moment().format("DD.MM.YYYY");
	public get EntdecktAm(): string {
		return this.entdecktAm;
	}
	public set EntdecktAm(value: string) {
		this.entdecktAm = value;
	}

	private entdecktUm: string;
	public get EntdecktUm(): string {
		return this.entdecktUm;
	}
	public set EntdecktUm(value: string) {
		this.entdecktUm = value;
	}

	private gasStation: GasStationModel;
	public get GasStation(): GasStationModel {
		return this.gasStation;
	}
	public set GasStation(value: GasStationModel) {
		this.gasStation = value;
	}

	private priceCorrection = new PriceCorrectionModel();
	public get PriceCorrection(): PriceCorrectionModel {
		return this.priceCorrection;
	}
	public set PriceCorrection(value: PriceCorrectionModel) {
		this.priceCorrection = value;
	}

	private gasStationCorrection = new GasStationCorrectionModel();
	public get GasStationCorrection(): GasStationCorrectionModel {
		return this.gasStationCorrection;
	}
	public set GasStationCorrection(value) {
		this.gasStationCorrection = value;
	}

	constructor(initialProperties?: Partial<FeedbackFormModel>) {
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	public static createFromObject(dataObject: { [key: string]: any }): FeedbackFormModel {
		return AppUtils.Helper.createFromMap(dataObject, FeedbackFormModel, (key, value) => {
			switch (key) {
				case 'gasStation':
				case 'GasStation':
					return GasStationModel.createFromObject(value);
				case 'priceCorrection':
				case 'PriceCorrection':
					return PriceCorrectionModel.createFromObject(value);
				case 'gasStationCorrection':
				case 'GasStationCorrection':
					return GasStationCorrectionModel.createFromObject(value);
				default:
					return value;
			}
		});
	}
}
